import MotionTime from './MotionTime'
import lottie from 'lottie-web'
import gsap from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
import contactIconAnimation from '../../anims/motiontime/contact.json'

gsap.registerPlugin(ScrollToPlugin)

export default class ContactIcon {
    constructor(scrollSystem = 'locomotive-scroll', locomotiveScrollInstance) {
        this.scrollSystem = scrollSystem
        this.locomotiveScrollInstance = locomotiveScrollInstance
        this.motionTime = new MotionTime()

        this.contactContainer = document.querySelector('.sidebar__contact')
        this.footer = document.querySelector('.footer--default')

        this.setupLottieAnimation()
        this.setupEvents()
    }

    setupLottieAnimation() {
        this.contactContainer.innerHTML = ''

        this.contactAnimationInstance = lottie.loadAnimation({
            path: contactIconAnimation,
            container: this.contactContainer,
            renderer: 'svg',
            loop: false,
            autoplay: false,
        })
    }

    setupEvents() {
        this.contactContainer.addEventListener('click', () => {
            if (this.scrollSystem == 'locomotive-scroll') {
                this.locomotiveScrollInstance.scrollTo(this.footer)
            } else {
                gsap.to(window, {
                    duration: 1,
                    ease: 'expo.out',
                    scrollTo: this.footer,
                })
            }
        })

        this.setupIntersectionObs()

        if (this.scrollSystem == 'locomotive-scroll') {
            this.locomotiveScrollInstance.on(
                'call',
                this.locomotiveCallEvent.bind(this)
            )
        }
    }

    setupIntersectionObs() {
        this.intersectionObs = new IntersectionObserver(
            (entry) => {
                if (entry[0].isIntersecting) {
                    this.contactContainer.classList.add('gone')
                    this.contactAnimationInstance.setDirection(1)
                    this.contactAnimationInstance.play()
                    this.motionTime.unlockItem(7)
                } else {
                    if (this.contactContainer.classList.contains('gone')) {
                        this.contactAnimationInstance.setDirection(-1)
                        this.contactAnimationInstance.play()
                        this.contactContainer.classList.remove('gone')
                    }
                }
            },
            {
                root: document.querySelector('null'),
                rootMargin: '-100px',
                treshold: [0, 1],
            }
        )

        this.intersectionObs.observe(this.footer)
    }

    locomotiveCallEvent(func, state) {
        if (func == 'footer') {
            this.contactIcon = document.querySelector('.sidebar__contact')

            if (state == 'exit') {
                if (this.contactContainer.classList.contains('gone')) {
                    this.contactAnimationInstance.setDirection(-1)
                    this.contactAnimationInstance.play()
                    this.contactContainer.classList.remove('gone')
                }
            } else if (state == 'enter') {
                this.contactContainer.classList.add('gone')
                this.contactAnimationInstance.setDirection(1)
                this.contactAnimationInstance.play()
                this.motionTime.unlockItem(7)
            }
        }
    }

    remove() {
        if (this.scrollSystem == 'locomotive-scroll') {
            // do nothing, we clear the locomotive scroll instance in templates anyway
        } else {
            this.intersectionObs.disconnect()
        }
    }
}
